<template>
    <div>
        <div class="form-group">
            <label for="video_title" class="control-label">{{$t('components.video.title')}}*</label>
            <input type="text" id="video_title" name="video_title" placeholder="e.g., Hatha Yoga" class="form-control" v-model="video.title">
        </div>
        <div class="form-group">
            <label for="video_desc" class="control-label">{{$t('components.video.description')}}*</label>
            <textarea type="textarea" id="video_desc" name="video_desc" placeholder="e.g., Your description here" class="form-control" v-model="video.description"></textarea>
        </div>
        <div class="form-group" v-show="!hideVisibilityVideo">
            <label for="video-visibility-option" class="control-label">{{$t('components.video.visibility')}}</label>

            <select v-show="!uploadingVideo" id="video-visibility-option" class="form-control" v-model="video.visibility">
                <option v-for="videoState in visibilityVideoOptions" :key="videoState.value"
                        :value="videoState.value">{{videoState.name}}</option>
            </select>
            <p v-show="uploadingVideo" class="form-control-static">
                <i class="las la-clock"></i> {{$t('components.video.uploading_video')}}
            </p>
        </div>
        <div class="form-group">
            <label for="language-options" class="control-label">{{$t('components.video.language')}}</label>
            <select id="language-options" class="form-control" v-model="video.language">
                <option v-for="language in languageOptions" :key="language.value"
                        :value="language.value">{{language.name}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    import {LANGUAGE_OPTIONS, VIDEO_VISIBILITY_OPTIONS} from "../../common/constants";
    import {Utils} from "../../common/utils";
    //TODO translate this placeholder page
    export default {
        name: "VideoForm",
        props: {
            videoProp: {
                type: Object,
                required: true
            },
            hideVisibilityVideo: {
                type: Boolean,
                default: false
            },
            uploadingVideo: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        },
        data: () => {
            return {
                visibilityVideoOptions: VIDEO_VISIBILITY_OPTIONS(),
                languageOptions: LANGUAGE_OPTIONS(),
                video: {
                    id: null,
                    title: null,
                    description: null,
                    video_id: null,
                    language: null,
                },
            }
        },
        mounted: function () {
            this.video = this.videoProp;
        },
        watch: {
            videoProp: function(newVal) {
                this.video = newVal;
            },
            video: {
                handler(newVal) {
                    this.$emit('change', newVal)
                },
                deep: true,
            }
        }
    }
</script>
